import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { AiSettingsService } from '../../service/ai-settings.service';
import { AiFeatureRequirement } from './ai-settings';

@Directive({ selector: '[fnIfAi]', standalone: true })
export class IfAiDirective implements OnInit, OnDestroy {
  @Input() fnIfAi: AiFeatureRequirement = 'Any';

  private shown = false;
  private sub: Subscription | null = null;

  constructor(private tpl: TemplateRef<unknown>, private vcr: ViewContainerRef, private ai: AiSettingsService) {}

  ngOnInit(): void {
    this.sub = this.ai.isEnabled$(this.fnIfAi).subscribe((on) => this.render(on));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private render(on: boolean): void {
    if (on && !this.shown) {
      this.vcr.createEmbeddedView(this.tpl);
      this.shown = true;
    } else if (!on && this.shown) {
      this.vcr.clear();
      this.shown = false;
    }
  }
}
